export const M_PER_KM = 1000;
export const M_PER_MILE = 1609.344;

export function formatDistance(meters: number, unit: 'km' | 'mi' = 'mi'): string {
  const divisor = unit === 'km' ? M_PER_KM : M_PER_MILE;
  const value = meters / divisor;
  return `${value.toFixed(value < 10 ? 2 : 1)} ${unit}`;
}

export function formatDuration(seconds: number): string {
  const s = Math.round(seconds);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

export function formatPace(secondsPerKm: number, unit: 'km' | 'mi' = 'mi'): string {
  if (!Number.isFinite(secondsPerKm) || secondsPerKm <= 0) return '—';
  const secondsPerUnit = unit === 'km' ? secondsPerKm : secondsPerKm * (M_PER_MILE / M_PER_KM);
  const m = Math.floor(secondsPerUnit / 60);
  const s = Math.round(secondsPerUnit % 60);
  return `${m}:${String(s).padStart(2, '0')} /${unit}`;
}

export function formatElevation(meters: number, unit: 'm' | 'ft' = 'ft'): string {
  const value = unit === 'ft' ? meters * 3.28084 : meters;
  return `${Math.round(value)} ${unit}`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

export function formatShortDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: '2-digit' });
}

export function typeLabel(type: string): string {
  return type.charAt(0).toUpperCase() + type.slice(1);
}
